import { Model } from '@nozbe/watermelondb'
import { field, json } from '@nozbe/watermelondb/decorators'


const sanitizeData = rawData => rawData

export class MilkDeliveriesModel extends Model {

  static table = 'milkDeliveries'

  @field('milkDeliveryId')
  milkDeliveryId: string

  @field('dairyFarmId')
  dairyFarmId: string

  @field('condemnedVolume')
  condemnedVolume: number

  @field('manual')
  manual: boolean

  @field('observation')
  observation: string

  @field('organizationId')
  organizationId: string

  @field('statusId')
  statusId: string

  @field('temperature')
  temperature: number

  @field('userId')
  userId: string

  @field('userStateRegistrationId')
  userStateRegistrationId: string

  @field('volume')
  volume: number

  @field('volumeDate')
  volumeDate: string

  @json('status', sanitizeData)
  status

  @field('createdAt')
  createdAt: string

  @field('updatedAt')
  updatedAt: string

}
